import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, A11y } from "swiper";
import "swiper/swiper-bundle.css";
import React from "react";
import AppointmentForm from "../../form/AppointmentForm";

SwiperCore.use([Autoplay, A11y]);

const VideoSection = ({ videoItems = [] }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [enableSwiper, setEnableSwiper] = React.useState(false);
  const [loadVideo, setLoadVideo] = React.useState(false);

  const firstItem = videoItems[0];

  React.useEffect(() => {
    const initSwiper = () => setEnableSwiper(true);

    if ("requestIdleCallback" in window) {
      requestIdleCallback(initSwiper);
    } else {
      setTimeout(initSwiper, 800);
    }
  }, []);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setLoadVideo(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <section className="gastro-care-banner video-banner">
      <img
        src="/assets/video/poster-desktop.webp"
        alt="Hospital Background"
        className="background-video desktop-video"
        fetchPriority="high"
      />
      {loadVideo && (
        <video
          className="background-video desktop-video"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
        >
          <source src="/assets/video/hyd-video-web-2.mp4" type="video/mp4" />
        </video>
      )}

      <img
        src="/assets/video/poster-mobile.webp"
        alt="Hospital Background"
        className="background-video mobile-video"
        fetchPriority="high"
      />
      {loadVideo && (
        <video
          className="background-video mobile-video"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
        >
          <source src="/assets/video/web-mobile-hyd.mp4" type="video/mp4" />
        </video>
      )}

      {firstItem && (
        <div className="container">
          <div className="text-content">
            <div className={`hero-static ${enableSwiper ? "hidden" : ""}`}>
              <h1 className="hero-title">{firstItem.title}</h1>
              <p className="hero-subtitle">{firstItem.subtitle}</p>
            </div>

            {enableSwiper && videoItems.length > 1 && (
              <Swiper
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                speed={800}
                slidesPerView={1}
                loop={false}
                className="video-title-swiper"
              >
                {videoItems.map((item, index) => (
                  <SwiperSlide key={index}>
                    <h1>{item.title}</h1>
                    <p>{item.subtitle}</p>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            <div className="button-group">
              <Link to="tel:+919994288800" className="btn btn-secondary">
                Contact Us
              </Link>
              <button
                className="btn btn-primary"
                onClick={() => setShowModal(true)}
              >
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      )}

      <AppointmentForm
        show={showModal}
        handleClose={() => setShowModal(false)}
        doctorName="Home Page / Video Banner"
      />
    </section>
  );
};

export default VideoSection;
